export default __webpack_public_path__ + "0385a6eb81d2bf346a5f0c16e7e3a2cc.png";